import { render } from "./EcommerceProducts.vue?vue&type=template&id=7db4ce33"
import script from "./EcommerceProducts.vue?vue&type=script&lang=js"
export * from "./EcommerceProducts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__